/**
 * Cost-Per-Can Chip — variant switching
 * Recalculates cost per can from embedded JSON data, updates chip.
 * No hardcoded prices, no DOM price parsing.
 *
 * Detection: observes #callBackVariant class changes (theme's swatch mechanism)
 * and #product-select change event as fallback.
 */
(function () {
  function init() {
    const dataEl = document.querySelector('[data-cost-per-can-data]');
    if (!dataEl || dataEl.dataset.costPerCanInitialized === 'true') return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const chipValue = document.querySelector('[data-cost-value]');
    if (!chipValue) return;
    dataEl.dataset.costPerCanInitialized = 'true';

    const select = document.getElementById('product-select');

    function update() {
      if (!select) return;
      const v = data.variants[select.value];
      if (!v || !v.packSize) return;
      const perCan = v.price / 100 / v.packSize;
      chipValue.textContent = '$' + perCan.toFixed(2);
    }

    // Observe #callBackVariant class changes (theme sets classes on swatch click)
    const cbv = document.getElementById('callBackVariant');
    if (cbv) {
      new MutationObserver(update).observe(cbv, { attributes: true, attributeFilter: ['class'] });
    }

    // Fallback: also listen for change event
    if (select) {
      select.addEventListener('change', function () { update(); });
    }
  }

  init();
  document.addEventListener('nc:combined-product:loaded', init);
})();
